module.exports = __webpack_public_path__ + "static/media/48.2557b192.png";